/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import InfluenceEnum from 'astro/enum/influence';

import * as UserValue from 'astro/value/user';


class Influence
{
  constructor (type, user, source, value)
  {
    this.type = type;
    this.user = user;
    this.source = source;

    this.value = value;
  }


  getUser ()
  {
    return this.user;
  }


  getUserID ()
  {
    return this.user;
  }


  getType ()
  {
    return this.type;
  }


  getSource ()
  {
    return this.source;
  }


  getValue ()
  {
    return this.value;
  }


}


export const makeAttrition = (user, source, value) =>
{
  return new Influence(InfluenceEnum.Attrition, user, source, value);
}


export const makeAttack = (user, source, value) =>
{
  return new Influence(InfluenceEnum.Attack, user, source, value);
}


export const makeNeighbor = (user, source, value) =>
{
  return new Influence(InfluenceEnum.Neighbor, user, source, value);
}


export const makeSector = (user, source, value) =>
{
  return new Influence(InfluenceEnum.Sector, user, source, value);
}


export const makePlatform = (user, source, value) =>
{
  return new Influence(InfluenceEnum.Platform, user, source, value);
}


export const makeFragment = (parent, ratio) =>
{
  const value = Math.floor(ratio * parent.getValue());

  return new Influence(parent.getType(), parent.getUser(), parent.getSource(), value);
}
